import { render, staticRenderFns } from "./VehicleRlsDetail.vue?vue&type=template&id=8a6733a8&scoped=true"
import script from "./VehicleRlsDetail.vue?vue&type=script&lang=js"
export * from "./VehicleRlsDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleRlsDetail.vue?vue&type=style&index=0&id=8a6733a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6733a8",
  null
  
)

export default component.exports